const matchPlayPage = {
  "match-play.header-title": "Modo Partido",
  "match-play.title": "Crece bajo presión",
  "match-play.subtitle": "Modo IA Match Play",
  "match-play.description": "Solo tú, el balón y juego implacable impulsado por IA. Demuestra lo que tienes cuando cuenta.",
  "match-play.game-speed": "Velocidad del Juego",
  "match-play.difficulty": "Dificultad",
  "match-play.game-duration": "Duración del Juego",
  "match-play.playing-position": "Posición de Juego",
  "match-play.your-position": "Tu Posición",
};

const settings = {
  "match-play.settings.speed.slow": "Lenta",
  "match-play.settings.speed.normal": "Normal",
  "match-play.settings.speed.fast": "Rápida",
};

const difficulty = {
  "match-play.settings.difficulty.beginner": "Principiante",
  "match-play.settings.difficulty.easy": "Fácil",
  "match-play.settings.difficulty.medium": "Media",
  "match-play.settings.difficulty.hard": "Difícil",
  "match-play.settings.difficulty.expert": "Experto",
};

export const matchPlay = {
  ...matchPlayPage,
  ...settings,
  ...difficulty,
};
